import { FC, useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import Collapse from "@mui/material/Collapse";
import { StarIcon } from "@heroicons/react/24/outline";
import { StarIcon as StarSolidIcon } from "@heroicons/react/24/solid";
import Flag from "../../../components/sport-table/flag";
import { HeaderWrapper } from "./styled";
import MatchTable from "./NewMatchTable";

export type TableMobileProps = {
  league: any;
  type: "live" | "today" | "early";
  sport:
    | "football"
    | "basketball"
    | "volleyball"
    | "tabletennis"
    | "handball"
    | "icehockey"
    | "tennis"
    | "snooker"
    | "baseball"
    | "rugby"
    | "americanfootball"
    | "cricket"
    | "badminton"
    | "boxing"
    | "bull_fight"
    | "cock_fight";
  onClickOddPrice?: (
    payload1: any,
  ) => (payload2: any) => (payload2: any) => void;
  onClickMore?: () => void;
  isFlagVisible?: boolean;
  onClickPinFavorite?: (
    payload: { id: string; name: string },
    type: "LEAGUE" | "TEAM",
  ) => void;
  onClickShare?: (data: { leagueId: string; matchId: string }) => void;
};

const TableMobile: FC<TableMobileProps> = ({
  league,
  onClickOddPrice,
  type,
  sport,
  onClickMore,
  isFlagVisible = false,
  onClickPinFavorite,
  onClickShare,
}) => {
  const { i18n } = useTranslation();
  const [isCollapse, setIsCollapse] = useState(true);
  const isLive = type === "live";

  const handle = onClickOddPrice?.({
    leagueId: `${league.k}`,
    leagueName: league.nn[i18n.language],
  });

  return (
    <>
      <HeaderWrapper isLive={isLive} className="flex p-2 mb-2">
        <div className="flex justify-between flex-1 items-center text-sm">
          <div className="flex items-center gap-x-2">
            <button
              className="align-text-bottom"
              onClick={() => {
                onClickPinFavorite?.(
                  {
                    id: `${league.k}`,
                    name: league.nn[i18n.language],
                  },
                  "LEAGUE",
                );
              }}>
              {Boolean(league.isFavorite) ?
                <StarSolidIcon className="w-5 h-5 text-yellow-400" />
              : <StarIcon className="w-5 h-5 text-yellow-400" />}
            </button>
            <button
              className="flex items-center gap-x-2"
              onClick={() => {
                setIsCollapse(!isCollapse);
              }}>
              {isFlagVisible && (
                <Flag
                  type="tournaments"
                  src={league?.fimg}
                  flagId={league.fid}
                />
              )}
              {league.nn[i18n.language]}
            </button>
          </div>
          <button
            className="px-2"
            onClick={() => {
              setIsCollapse(!isCollapse);
            }}>
            <svg
              width="12"
              height="8"
              viewBox="0 0 8 5"
              fill="currentColor"
              className={classNames("transition-transform align-baseline", {
                "rotate-180": !isCollapse,
                "rotate-0": isCollapse,
              })}>
              <path d="M7.369 0H.199l3.585 4.2L7.369 0z"></path>
            </svg>
          </button>
        </div>

        {/* <div className="flex">
          <div className="w-16 flex items-center justify-center text-sm">Home</div>
          <div className="w-16 flex items-center justify-center text-sm">Away</div>
        </div> */}
      </HeaderWrapper>
      <Collapse in={isCollapse}>
        {league.m.map((match: any) => {
          const handleShare =
            onClickShare ?
              () =>
                onClickShare({
                  leagueId: String(league.k),
                  matchId: String(match.k),
                })
            : undefined;

          return (
            <MatchTable
              isFlagVisible={isFlagVisible}
              key={match.k}
              leagueId={`${league.k}`}
              onClickOddPrice={handle}
              onClickMore={onClickMore}
              match={match}
              type={type}
              sport={sport}
              various="normal"
              onClickShare={handleShare}
            />
          );
        })}
      </Collapse>
    </>
  );
};

export default TableMobile;
